export default __webpack_public_path__ + "static/media/plow-scarecrow--240.e2f666b4.jpg";